<template>
    <section class="section-padding" id="training-header">
      <div class="container-fluid container-lg">
        <div class="row justify-content-center align-items-center">
          <div class="col-12 col-md-10 mx-auto text-center">
                <div class="training-text">
                    <h1>Become a Professional Software Developer</h1>
                  <div class="mt-4">
                    <p>Get up your software development journey faster by enrolling for a top-notch training from experts of strong years of experience today.</p>
                  </div>
                  <div class="pt-4">
                    <a href="#register" class="training-button-ico shadow-lg"><i class="fa fa-arrow-down"></i></a>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>  
  export default {
    
  }
  </script>
  
  <style>
  #training-header {
    background-image: url("../assets/trainingbg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  #training-header.section-padding {
  padding-top: 7rem !important;
  padding-bottom: 7rem !important;
}
  
  #training-header::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: var(--dacode-primary-color) !important;
    opacity: .9;
  }
  
  #training-header, .training-text {
    position: relative;
    z-index: 10;
  }
  
  #training-header h1{
    color: var(--dacode-secondary-color);
    font-size: 2.5rem;
    text-align: center;
  }
  
  #training-header p {
    font-size: 1rem;
    color: var(--dacode-white-color);
    letter-spacing: 2px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.92);
  }
  
  .training-button-ico {
    background-color: var(--dacode-secondary-color) !important;
    padding: 1rem 3rem;
    color: var(--dacode-white-color) !important;
    border: 2.5px solid var(--dacode-secondary-color);
    border-radius: 1000px;
    display: inline-block;
    transition: 500ms;
    filter: drop-shadow(0px 5px 5px var(--dacode-secondary-color))
  }

  .training-button-ico i {
    font-size: 20px;
  }

  .training-button-ico:hover {
    transform: translateY(-8px);
  }
  </style>
  
  